export default __webpack_public_path__ + "static/media/Logout.d2b5ecdb.svg";